import { useState } from "react";
import { Plane } from "lucide-react";
import { useDemo } from "@/store/DemoStore";
import { CURRENT_CLIENT_ID } from "@/data/constants";
import { Empty, Segmented } from "@/components/common";
import { TripCard } from "@/components/TripCard";
import { daysUntil } from "@/lib/trip";

export default function ClientTrips() {
  const { tripsFor, paidExtra } = useDemo();
  const trips = tripsFor(CURRENT_CLIENT_ID);
  const [tab, setTab] = useState("UPCOMING");
  const groups = {
    UPCOMING: trips.filter((t) => t.status === "BOOKED" && daysUntil(t.departure) >= 0),
    QUOTED: trips.filter((t) => t.status === "QUOTE"),
    COMPLETED: trips.filter((t) => t.status === "COMPLETED" || (t.status === "BOOKED" && daysUntil(t.departure) < 0)),
  };
  const list = groups[tab];

  return (
    <div>
      <h1 className="font-display text-2xl font-bold tracking-tight text-navy-900 sm:text-3xl" data-testid="page-title">My Trips</h1>
      <p className="mt-1 text-sm text-slate-500">Everything planned with your advisor.</p>
      <div className="mb-5 mt-5">
        <Segmented testPrefix="client-trips-filter" value={tab} onChange={setTab} options={[["UPCOMING", "Upcoming"], ["QUOTED", "Quoted"], ["COMPLETED", "Completed"]].map(([v, l]) => ({ value: v, label: l, count: groups[v].length }))} />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {list.map((t) => <TripCard key={t.id} trip={t} to={`/mytrip/trips/${t.id}`} paidExtra={paidExtra(t.id)} />)}
      </div>
      {!list.length && <Empty icon={Plane} title="Nothing here yet" text="Your advisor will add trips as they're planned." />}
    </div>
  );
}
